import React from 'react';

const FlagBe = props => (
  <svg viewBox="0 0 450 390" {...props}>
    <path fill="#ED2939" d="M0 0h450v390H0z" />
    <path fill="#FAE042" d="M0 0h300v390H0z" />
    <path d="M0 0h150v390H0z" />
  </svg>
);

export default FlagBe;
